



























import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { Location } from "vue-router";
import ContributionScheduleTabs from "@/shared/components/contributionsV3/ContributionScheduleTabs.vue";
import { PersonalContributionSchedule } from "@/shared/types";
import FutureContributions from "@/shared/components/contributionsV3/FutureContributions.vue";

@Component({
  components: {
    ContributionScheduleTabs,
    FutureContributions
  }
})
export default class ManageContributionsPage extends Vue {

  @Prop()
  schedulesPage: number;

  @Prop()
  schedulesFilter: string;

  @Prop()
  futureContributionsPage: number;

  @Prop()
  routeToModifySchedule: (schedule: PersonalContributionSchedule) => Location;

  pageSize = 10;

}
